import React from "react";

const Home2 = () => {
  return (
    <section className="home2-section" id="home2">
      <div className="home2-glasscard">
        <div className="home2-textblock">
          <h2 className="home2-title">
            Unsere <span className="highlight2">Top-Talente</span> für ihr <span className="highlight2">Projekt</span> - schnell, passgenau & zuverlässig.
          </h2>
          <p className="home2-text">
            Qlance bringt Herausforderungen mit Expertise zusammen.<br />
            Ob Expansionsplanung, Marktanalyse oder digitale Transformation – wir vernetzen Menschen mit Vision.
          </p>
          <button className="btn" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
            <div>JETZT STARTEN</div>
          </button>
        </div>
          <div className="home2-arrows">
            <span className="arrow arrow-left">↑</span>
            <span className="arrow arrow-right">↑</span>
          </div>
      </div>

      <div className="home2-image-fullwidth">
        <img src="/assets/meeting1.jpg" alt="Meeting" className="home2-image-full" />
        <div className="home2-image-darklayer" />
        <div className="home2-image-overlay-text">PERSONALPLANUNG NEU GEDACHT</div>
      </div>
    </section>
  );
};

export default Home2;
